<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-toolbar color="transparent elevation-0">
          <v-btn
            :disabled="showDetails === true"
            outlined
            color="success"
            class="mr-3"
            @click="
              showRegistrants = false
              showDetails = true
            "
          >
            {{ $vuetify.lang.t('$vuetify.DETAILS') }}
          </v-btn>
          <v-btn
            v-if="campaign && campaign.ID > 0 && !campaign.IsTemplate && !isNew"
            :disabled="showRegistrants === true || isNew"
            outlined
            color="success"
            :loading="loading.type === 'getRegistrants'"
            @click="getCampaignRegistrats()"
          >
            {{ $vuetify.lang.t('$vuetify.DASHBOARD.REGISTRANTS') }}
          </v-btn>
        </v-toolbar>
        <v-card class="elevation-3">
          <v-card-title class="body-1">
            <v-spacer></v-spacer>
            <v-btn icon small @click="closeForm()">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-toolbar
            v-if="loading.state && loading.type === 'getCampaign'"
            class="elevation-0"
          >
            <v-spacer></v-spacer>
            <v-progress-circular
              indeterminate
              color="secondary"
            ></v-progress-circular>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text v-else>
            <campaign-form
              v-show="!showRegistrants"
              :campaign-id="id"
              @valid="saveButtonDisabled = false"
              @invalid="saveButtonDisabled = true"
            />
            <div v-show="showRegistrants">
              <v-data-table
                :headers="[
                  {
                    text: $vuetify.lang.t(
                      '$vuetify.EDIT_WHITELISTS.PHONE_NUMBER'
                    ),
                    align: 'start',
                    sortable: false,
                    value: 'PhoneNumber'
                  },
                  {
                    text: $vuetify.lang.t(
                      '$vuetify.EDIT_WHITELISTS.CAR_NUMBERS'
                    ),
                    sortable: false,
                    value: 'Carumber'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.NAME'),
                    sortable: true,
                    value: 'Name'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.EMAIL'),
                    sortable: true,
                    value: 'Email'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.VALID_FROM'),
                    sortable: true,
                    value: 'ValidFrom'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.VALID_TO'),
                    align: 'center',
                    sortable: false,
                    value: 'ValidTo'
                  },
                  {
                    text: 'Discount (EUR)',
                    align: 'center',
                    sortable: false,
                    value: 'Discount'
                  },
                  {
                    text: $vuetify.lang.t(
                      '$vuetify.FLEET_REPORT.USED_FLEET_CREDIT'
                    ),
                    align: 'center',
                    sortable: false,
                    value: 'UsedDiscountCreditInCents'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.REG_TYPE'),
                    sortable: true,
                    sortable: false,
                    value: 'RegistrationType'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.REG_TIME'),
                    sortable: true,
                    value: 'CreatedAt'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.STATUS'),
                    value: 'Status'
                  },
                  { text: '', sortable: false, value: 'actions' }
                ]"
                :items="registrants"
                hide-default-footer
                class="elevation-1"
                item-key="Id"
                :items-per-page="-1"
              >
                <template v-slot:top>
                  <v-toolbar flat class="mt-4">
                    <v-spacer></v-spacer>
                    <vue-xlsx-table @on-select-file="onInviteFileSelect">
                      <v-btn small text>
                        <v-icon class="mr-2">mdi-file-import</v-icon>
                        {{ $vuetify.lang.t('$vuetify.INVITE_FROM_FILE') }}
                      </v-btn>
                    </vue-xlsx-table>
                    <v-menu offset-y dense>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on">
                          <v-icon>mdi-dots-horizontal</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item @click="downloadTemplateFile()">
                          <v-list-item-title>
                            <v-icon small class="mr-2">mdi-download</v-icon>
                            {{
                              $vuetify.lang.t('$vuetify.DOWNLOAD_TEMPLATE_FILE')
                            }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-btn
                      color="success"
                      text
                      small
                      @click="openEditCampaignRegistrantDialog(true)"
                    >
                      <v-icon class="mr-2">mdi-plus</v-icon>
                      {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.INVITE') }}
                    </v-btn>

                    <v-divider vertical inset></v-divider>

                    <vue-xlsx-table @on-select-file="onFileSelect">
                      <v-btn small text>
                        <v-icon class="mr-2">mdi-file-import</v-icon>
                        {{ $vuetify.lang.t('$vuetify.IMPORT_FROM_FILE') }}
                      </v-btn>
                    </vue-xlsx-table>
                    <v-menu offset-y dense>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on">
                          <v-icon>mdi-dots-horizontal</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item @click="downloadTemplateFile()">
                          <v-list-item-title>
                            <v-icon small class="mr-2">mdi-download</v-icon>
                            {{
                              $vuetify.lang.t('$vuetify.DOWNLOAD_TEMPLATE_FILE')
                            }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-btn
                      color="success"
                      text
                      small
                      @click="openEditCampaignRegistrantDialog(false)"
                    >
                      <v-icon class="mr-2">mdi-plus</v-icon>
                      {{ $vuetify.lang.t('$vuetify.WHITELISTS.ADD_NEW') }}
                    </v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:item.ValidFrom="props">
                  <td>
                    {{
                      formatDate(
                        getDateInTimeZone(
                          props.item.ValidFrom,
                          campaign.TimeZone
                        )
                      )
                    }}
                  </td>
                </template>
                <template v-slot:item.ValidTo="props">
                  <td class="d-flex justify-center">
                    {{
                      formatDate(
                        getDateInTimeZone(props.item.ValidTo, campaign.TimeZone)
                      )
                    }}
                  </td>
                </template>
                <template v-slot:item.RegistrationType="{ item }">
                  <td>
                    {{ registrationTypeText(item) }}
                  </td>
                </template>
                <template v-slot:item.Discount="props">
                  <td>
                    {{ props.item.DiscountCreditInCents / 100 }}
                    {{ campaign.DiscountCreditCurrency }}
                  </td>
                </template>
                <template v-slot:item.UsedDiscountCreditInCents="props">
                  <td>
                    {{ props.item.UsedDiscountCreditInCents / 100 }}
                    {{ campaign.DiscountCreditCurrency }}
                  </td>
                </template>
                <template v-slot:item.CreatedAt="props">
                  <td>{{ dateEE(props.item.CreatedAt, '.') }}</td>
                </template>
                <template v-slot:item.Status="props">
                  <td>
                    <span
                      v-if="!isRegistrantStatusEmptyOrPending(props.item)"
                      :class="{
                        'error--text': isRegistrantStatusDeclined(props.item),
                        'success--text': isRegistrantStatusApproved(props.item)
                      }"
                    >
                      {{ props.item.Status }}
                    </span>
                    <br />
                    <span
                      v-if="isRegistrantInvitePending(props.item)"
                      class="orange--text"
                    >
                      INVITE PENDING
                    </span>
                    <span
                      v-if="isRegistrantInviteAccepted(props.item)"
                      class="success--text"
                    >
                      INVITE ACCEPTED
                    </span>
                  </td>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="position: fixed; right: 36px; bottom: 36px;"
              color="primary"
              class="secondary--text"
              :disabled="saveButtonDisabled"
              @click="saveCampaign()"
            >
              {{ $vuetify.lang.t('$vuetify.SAVE') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <edit-campaign-registrant-dialog
          v-if="selectedUser"
          :selected-user="selectedUser"
          :visible="editCampaignRegistrantDialog"
          @close="
            editCampaignRegistrantDialog = false
            selectedUser = null
          "
        />
        <v-dialog v-model="userImportConfirmDialog" width="700">
          <v-card>
            <v-card-title class="headline lighten-2" primary-title>
              {{ $vuetify.lang.t('$vuetify.PREVIEW') }}
              <v-spacer></v-spacer>
              <v-btn icon small @click="userImportConfirmDialog = false">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.EDIT_WHITELISTS.PHONE_NUMBER'
                          )
                        }}
                      </th>
                      <th class="text-left">
                        {{
                          $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.CAR_NUMBER')
                        }}
                      </th>
                      <th class="text-left">
                        {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.NAME') }}
                      </th>
                      <th class="text-left">
                        {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.EMAIL') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in arrayOfMappedImportedUsers"
                      :key="item.name"
                    >
                      <td>{{ item.PhoneNumber }}</td>
                      <td>
                        {{
                          item.CarNumber && item.CarNumber !== ''
                            ? item.CarNumber
                            : '-'
                        }}
                      </td>
                      <td>{{ item.Name }}</td>
                      <td>{{ item.Email }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="secondary--text"
                text
                @click="postUsers()"
              >
                {{ $vuetify.lang.t('$vuetify.SAVE') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import formatDate from '@/mixins/formatDate'
import CampaignForm from '@/components/CampaignForm'
import Campaign from '@/models/campaign'
import DiscountCampaignRegistrant from '@/models/discount-campaign-registrant'

export default {
  name: 'Campaign',
  components: {
    CampaignForm,
    EditCampaignRegistrantDialog: () =>
      import(
        /* webpackChunkName: "EditCampaignRegistrantDialog" */ '@/components/EditCampaignRegistrantDialog'
      )
  },
  mixins: [formatDate],
  props: {
    id: String
  },
  data() {
    return {
      saveButtonDisabled: true,
      showRegistrants: false,
      showDetails: true,
      languages: [
        'ENG',
        'EST',
        'RUS',
        'BUL',
        'LAV',
        'LTU',
        'HUN',
        'CZE',
        'UKR',
        'POL',
        'FIN'
      ],
      userImportConfirmDialog: false,
      arrayOfMappedImportedUsers: [],
      editCampaignRegistrantDialog: false,
      selectedUser: null,
      inviting: false
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('campaigns', ['campaign', 'registrants', 'isNew'])
  },
  watch: {
    userImportConfirmDialog(newValue) {
      if (newValue === false) {
        this.inviting = false
      }
    }
  },
  created() {
    if (this.id > 0) {
      this.getCampaign(this.id)
      if (this.id !== this.currentCampaignId) {
        this.$store.commit('campaigns/setCurrentCampaignId', this.id)
      }
    }
  },
  methods: {
    ...mapActions('campaigns', ['getCampaign', 'getRegistrants']),
    isRegistrantStatusEmptyOrPending(registrant) {
      if (registrant.Status === '' || registrant.Status === 'PENDING') {
        return true
      }
      return false
    },
    isRegistrantInvitePending(registrant) {
      return registrant.InviteUuid !== '' && registrant.ClientId === 0
    },
    isRegistrantInviteAccepted(registrant) {
      return registrant.InviteUuid !== '' && registrant.ClientId !== 0
    },
    isRegistrantStatusApproved(registrant) {
      return registrant.Status === 'APPROVED'
    },
    isRegistrantStatusDeclined(registrant) {
      return registrant.Status === 'DECLINED'
    },
    async saveCampaign() {
      try {
        await this.$store.dispatch(
          'campaigns/saveCampaign',
          this.$store.state.campaigns.campaign
        )
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error in saveCampaign:', error)
      }
    },
    closeForm() {
      if (this.showRegistrants) {
        this.showRegistrants = false
        this.showDetails = true
      } else {
        this.$router.replace('/campaigns')
        this.$store.commit('campaigns/setCampaign', new Campaign().getObject())
      }
    },
    getCampaignRegistrats() {
      this.getRegistrants(this.id)
      this.showDetails = false
      this.showRegistrants = true
    },
    registrationTypeText(registrationType) {
      switch (registrationType.RegistrationType) {
        case 'MANUALLY_ADDED':
          return 'Manual'
        case 'LINK_REGISTRATION':
          return 'Public Link'
        case 'CAMPAIGN_CODE':
          return 'Campaign Code'
        case 'ONE_TIME_PROMO_CODE':
          return 'One-time promo code'
        default:
          return 'Other'
      }
    },
    onInviteFileSelect(files) {
      this.inviting = true
      this.userImportConfirmDialog = true
      if (this.arrayOfMappedImportedUsers.length) {
        this.arrayOfMappedImportedUsers = []
      }
      files.body.forEach(user => {
        this.arrayOfMappedImportedUsers.push({
          Name: user.Name,
          Email: user.Email,
          PhoneNumber: user['Phone number'],
          CarNumber: user['Car number'],
          RegistrationType: 'MANUALLY_INVITED'
        })
      })
    },
    onFileSelect(files) {
      this.userImportConfirmDialog = true
      if (this.arrayOfMappedImportedUsers.length) {
        this.arrayOfMappedImportedUsers = []
      }
      files.body.forEach(user => {
        this.arrayOfMappedImportedUsers.push({
          Name: user.Name,
          Email: user.Email,
          PhoneNumber: user['Phone number'],
          CarNumber: user['Car number'],
          RegistrationType: 'MANUALLY_ADDED'
        })
      })
    },
    downloadTemplateFile() {
      const a = document.createElement('a')
      a.href = 'https://admin.barking.ee/static/users_import_template.xlsx'
      a.setAttribute('download', 'users_import_template.xlsx')
      a.click()
    },
    openEditCampaignRegistrantDialog(invite) {
      this.$store.commit('campaigns/setInviting', invite)
      this.selectedUser = new DiscountCampaignRegistrant().getObject()
      this.editCampaignRegistrantDialog = true
    },
    postUsers() {
      this.$store.dispatch('campaigns/postRegistrants', {
        campaignId: this.campaign.ID,
        many: true,
        invite: this.inviting,
        data: this.arrayOfMappedImportedUsers
      })
      this.userImportConfirmDialog = false
    }
  }
}
</script>
<style scoped>
::v-deep .vue-xlsx-container .xlsx-button {
  background-color: transparent;
  border: none;
}
</style>
